import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingSpinner } from '../components/LoadingSpinner';
import { establishRecoverySession } from '../utils/recoverySession';

/**
 * Handles PKCE-style auth email links:
 * /auth/confirm?token_hash=...&type=recovery&next=/reset-password
 */
const AuthConfirm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let cancelled = false;

    const confirm = async () => {
      const result = await establishRecoverySession();
      if (cancelled) return;

      const next = searchParams.get('next') || '/reset-password';

      if (result.status === 'ready') {
        navigate(next, { replace: true });
        return;
      }

      // Keep the expired/invalid message on the reset page instead of dropping
      // the user on forgot-password with no explanation.
      navigate('/reset-password?error=access_denied&error_code=otp_expired', { replace: true });
    };

    void confirm();

    return () => {
      cancelled = true;
    };
  }, [navigate, searchParams]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <LoadingSpinner size="large" />
    </div>
  );
};

export default AuthConfirm;
